import React, {useEffect, useState} from 'react';
import {
    Avatar, Backdrop,
    Box, Button,
    Card, CardActions,
    CardHeader, Collapse, Fade, IconButton,
    List, ListItem,
    ListItemAvatar, ListItemText, Modal, Typography, useTheme
} from "@material-ui/core";
import {makeStyles} from '@material-ui/core/styles';
import clsx from 'clsx';
import Tooltip from '@material-ui/core/Tooltip';

import {ReactComponent as TripsIcon} from '../assets/fontAwesome/route.svg';
import DirectionsBikeIcon from '@material-ui/icons/DirectionsBike';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ScheduleIcon from '@material-ui/icons/Schedule';
import PolicyIcon from '@material-ui/icons/Policy';
import CallIcon from '@material-ui/icons/Call';
import NotListedLocationIcon from '@material-ui/icons/NotListedLocation';
import BluetoothSearchingIcon from '@material-ui/icons/BluetoothSearching';
import ClearIcon from '@material-ui/icons/Clear';
import DoneIcon from '@material-ui/icons/Done';
import LaunchIcon from '@material-ui/icons/Launch';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import PinDropIcon from '@material-ui/icons/PinDrop';

import Map from "../Components/Map/Map";
import Fireworks from '../Components/Fireworks'
import Snackbar from "../Components/Snackbar";
import TripsDrawer from "../Components/Trips/TripsDrawer";
import RoomIcon from "@material-ui/icons/Room";
import ExploreIcon from '@material-ui/icons/Explore';
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import {useLocation} from "react-router-dom";
import axios from "axios";
import { endpoints } from "../constants";
import { formatDateTime, formatDateTimeToLastSeen, copyLocation } from '../helpers'

export const useStyles = makeStyles((theme) => ({
    root: {
        height: "100%",
        flex: 1,
        display: "flex",
        flexDirection: "column"
    },
    card: {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        overflow: "auto",
        maxHeight: "60vh",
        textAlign: "left",
        borderRadius: 0,

        [theme.breakpoints.up('md')]: {
            bottom: "1rem",
            left: "1rem",
            right: "1rem",
            position: "absolute",
            width: "400px",
            borderRadius: '8px'
        }
    },
    list: {
        position: "relative",
        width: "100%",
        backgroundColor: theme.palette.background.paper,
        overflow: "auto",
        maxHeight: '600px',
        opacity: 1,
        transition: 'all 0.5s ease'
    },
    listMinimized: {
        position: "relative",
        width: "100%",
        backgroundColor: theme.palette.background.paper,
        maxHeight: '0px',
        opacity: 0,
        transition: 'all 0.5s ease',
    },
    actions: {
        marginLeft: 'auto',
    },
    listItem: {
        padding: '0 16px 0 72px'
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        outline: 'none',
        border: 'none'
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(3, 8, 3),
        borderRadius: '10px',
        outline: 'none',
        border: 'none'
    },
    caseClosed: {
        border: '4px solid #173c60',
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(3, 8, 3),
        borderRadius: '5px',
        outline: 'none',
    },
    expand: {
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    address: {
        paddingTop: 0,
        paddingBottom: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: "0.75rem",
        color: theme.palette.text.secondary,
    },
    avatar: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.type === 'dark' ? 'white' : '#173c60'
    },
    buttonContinue: {
        padding: '8px 22px',
        backgroundColor: '#41D882',
        color: '#fff',
        margin: '10px 10px 0 10px',
        minWidth: '100px'
    },
    buttonCancel: {
        padding: '8px 22px',
        backgroundColor: '#FF7674',
        color: '#fff',
        margin: '10px 10px 0 10px',
        minWidth: '100px'
    },
    bluetoothOn: {
        color: '#173c60'
    },
    sizeButtonMaximize: {
        transition: 'transform 0.5s ease',
        transform: 'rotate(180deg)'
    },
    sizeButtonMinimize: {
        transition: 'transform 0.5s ease',
    },
    backDrop: {
        backdropFilter: "blur(12px)",
        backgroundColor:'rgba(0,0,30,0.4)'
    }
}));

const Details = () => {
    const classes = useStyles()
    const theme = useTheme()
    const [actions, setActions] = useState<string[]>([])
    const [lastSeen, setLastSeen] = useState('')
    const [expandedEvent, setExpandedEvent] = useState(false)
    const [expandedVehicle, setExpandedVehicle] = useState(false)
    const [snackbar, setSnackbar] = useState<{message: string, open: boolean, severity: 'info' | 'success' | 'error'}>({ message: '', open: false, severity: 'success'})
    const [currentLocation, setCurrentLocation] = useState("none")
    const [informationMaximized, setInformationMaximized] = useState(true)
    const [mapLocation, setMapLocation] = useState({ lat: 0, lng: 0})
    const [gpsLocation, setGpsLocation] = useState({ lat: 0, lng: 0})
    const [modalOpen, setModalOpen] = useState(false)
    const [modalCase, setModalCase] = useState({type: 'resolve', text: 'Bike successfully recovered?'})
    const [closedCaseModalOpen, setClosedCaseModalOpen] = useState(false)
    const [events, setEvents] = useState<any [] | null>(null)
    const [contactInfo, setContactInfo] = useState<any>({})
    const [bikeInfo, setBikeInfo] = useState<any>({})
    const [caseInfo, setCaseInfo] = useState<any>({})
    const [margin, setMargin] = useState(100);
    const [bluetoothOn, setBluetoothOn] = useState(false)
    const [enableFireworks, setEnableFireworks] = useState(false)
    const [tripsDrawerOpen, setTripsDrawerOpen] = useState(false)
    const [trip, setTrip] = useState<Array<{lat: number, lng: number}> | null>(null);
    const [errorOnLoad, setErrorOnLoad] = useState(false)

    const location = useLocation()
    const { backendEndpoint, liveUpdatesEndpoint } = endpoints
    const id = location.pathname.substr(1)



    useEffect(() => {
        axios.get(`${backendEndpoint}/investigations/${id}`).then((res) => {
            const data = res.data.data

        const { number, token, trips, events, actions } = data
            setActions(actions)
            setCaseInfo({ trips, caseNumber: String(number), token})
            setEvents(events.map((e:any) => { return {...e, date: formatDateTime(e.date)} }))
        const { first_name, last_name, phone } = data.reporter;
            setContactInfo({ name: `${first_name} ${last_name}`, phone })
        const { imei, received_at, margin, model, brand, frame_number, name, type, color, license_plate} = data.entity
            setBikeInfo({ name, brand, model, imei, frameNumber: frame_number, type, color, licensePlate: license_plate })
            setLastSeen(formatDateTimeToLastSeen(received_at))
        const { lat, lng } = data.entity.location;
            setMargin(margin === 0 ? 100 : margin)
            setMapLocation({lat, lng})
            setGpsLocation({lat,lng})
        }).catch((e: any) => {
            setErrorOnLoad(true)
            setClosedCaseModalOpen(true)
        })
    }, [backendEndpoint, location.pathname, id])

    useEffect(() => {
        const eventStream = new EventSource(`${liveUpdatesEndpoint}/real-time/investigations?case_id=${id}`)

        eventStream.onmessage = (m: any) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const [_, location, positionedAt, margin] = JSON.parse(m.data)
            setMapLocation(location)
            setGpsLocation(location)
            setLastSeen(formatDateTimeToLastSeen(positionedAt))
            setMargin(margin)
        }
    },[id, liveUpdatesEndpoint])

    useEffect(() => {
        if(tripsDrawerOpen === false) {
            setTrip(null)
            setMapLocation(gpsLocation)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tripsDrawerOpen])

    const turnOnBluetooth = () => {
            if (!bluetoothOn) {
                axios.put(`${backendEndpoint}/investigations/${id}/commands/bluetooth`).then(() => {
                    setBluetoothOn(true)
                    setSnackbar({message: 'Bluetooth switched on!', open: true, severity: 'success' })
                    setTimeout(() => setBluetoothOn(false), 600000)
                }).catch(err => setSnackbar({message: err.message, open: true, severity: 'error' }))
            }
    }

    const requestRecentLocation = () => {
            axios.put(`${backendEndpoint}/investigations/${id}/commands/locate`).then(() => {
                setSnackbar({message: 'Location request sent to tracker!', open: true, severity: 'success' })
            }).catch((err) => setSnackbar({message: err.message, open: true, severity: 'error' }))
    }

    const shareLocation = () => {
        copyLocation(`${window.location.origin}/follow/${caseInfo.token}`)
        setSnackbar({message: 'Tracking url copied!', open: true, severity: 'success' })
    }

    const modalHandler =  (type: string, text: string) => {
        setModalCase({ type, text })
        setModalOpen(true)
    }

    return (
        <Box className={classes.root}>
                <Map location={mapLocation} margin={margin} trip={trip} setCurrentLocation={setCurrentLocation} />
                <Card className={classes.card}>
                    <CardHeader
                        action={
                            <Tooltip title="Copy follow page url to clipboard">
                                <IconButton style={{color: '#EEF0F2', marginTop: '10px'}} aria-label="share" onClick={shareLocation}>
                                    <LaunchIcon />
                                </IconButton>
                            </Tooltip>
                        }
                        title={<Typography style={{marginLeft: '8px'}}>Case: {caseInfo.caseNumber}</Typography>}
                        style={{backgroundColor: theme.palette.primary.main, color: 'white', padding: '4px 14px'}}
                    />

                    <CardActions disableSpacing>
                        {actions.includes('resolve') && (<Tooltip title="Resolve this case">
                            <IconButton aria-label="resolve" style={{color: theme.palette.success.main}}
                                        onClick={() => modalHandler('resolve', 'Bike successfully recovered?')}>
                                <DoneIcon/>
                            </IconButton>
                        </Tooltip>)}
                        {actions.includes('close') && (<Tooltip title="Close this case">
                            <IconButton aria-label="close" style={{color: theme.palette.error.main}}
                                        onClick={() => modalHandler('close', 'Bike is NOT recovered. Close case?')}>
                                <ClearIcon/>
                            </IconButton>
                        </Tooltip>)}
                        {actions.includes('snooze') && (<Tooltip title="Snooze this case until new movement">
                            <IconButton aria-label="snooze" style={{color: theme.palette.warning.main}}
                                        onClick={() => modalHandler('snooze', 'Snooze case?')}>
                                <ScheduleIcon/>
                            </IconButton>
                        </Tooltip>)}

                        <Box className={classes.actions}>
                            <Tooltip title={tripsDrawerOpen ? "Back to location" : "Open trips drawer"} >
                                <IconButton aria-label="bluetooth" onClick={() => setTripsDrawerOpen(!tripsDrawerOpen)} >
                                    {tripsDrawerOpen ? <PinDropIcon/> : <TripsIcon fill={theme.palette.type === 'dark' ? 'white' : '#757575'} style={{height: '24px'}}/> }
                                </IconButton>
                            </Tooltip>

                            <Tooltip title={bluetoothOn ? "Bluetooth on" : "Turn bluetooth on"}>
                                <IconButton aria-label="bluetooth" onClick={turnOnBluetooth} className={bluetoothOn ? classes.bluetoothOn : ''} >
                                    <BluetoothSearchingIcon />
                                </IconButton>
                            </Tooltip>

                            <Tooltip title={"Request new location"}>
                              <IconButton aria-label="location" onClick={requestRecentLocation}>
                                    <NotListedLocationIcon/>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={informationMaximized ? "Minimize information" : "Maximize information"} >
                                <IconButton onClick={() => setInformationMaximized(!informationMaximized)} className={informationMaximized ? classes.sizeButtonMinimize : classes.sizeButtonMaximize}>
                                    <ExpandMoreIcon />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    </CardActions>
                    <List className={informationMaximized ? classes.list : classes.listMinimized}>
                        <ListItem>
                            <ListItemAvatar>
                                <Avatar className={classes.avatar}>
                                    <RoomIcon/>
                                </Avatar>
                            </ListItemAvatar>
                                <ListItemText primary={currentLocation === 'none' ? 'No close address found...' : currentLocation} />
                            <Tooltip title={"Open in google maps"} >
                                <IconButton onClick={() => window.open(`https://www.google.com/maps/place/${currentLocation.replaceAll(' ', '+')}/`, "_blank")} >
                                    <ExploreIcon style={{color: theme.palette.type === 'dark' ? 'white' : '#173c60'}}/>
                                </IconButton>
                            </Tooltip>
                        </ListItem>
                        <ListItem>
                            <ListItemAvatar>
                                <Avatar className={classes.avatar}>
                                    <PolicyIcon/>
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={'Logs'} />
                            <IconButton
                                className={clsx(classes.expand, {
                                    [classes.expandOpen]: expandedEvent,
                                })}
                                onClick={() => setExpandedEvent(!expandedEvent)}
                                aria-expanded={expandedEvent}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon style={{color: theme.palette.type === 'dark' ? 'white' : '#173c60'}}/>
                            </IconButton>
                        </ListItem>
                        <Collapse in={expandedEvent} timeout="auto" unmountOnExit>
                            {events && events.map((e: any, i) => <List key={i} className={classes.list}>
                                <ListItemText primary={e.message} secondary={e.date}
                                              className={classes.listItem}/>
                            </List>)}
                        </Collapse>
                        <ListItem>
                            <ListItemAvatar>
                                <Avatar className={classes.avatar}>
                                    <DirectionsBikeIcon/>
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={bikeInfo.name || ''} secondary={`${bikeInfo.color || ''} ${bikeInfo.type || ''}`}/>
                            <IconButton
                                className={clsx(classes.expand, {
                                    [classes.expandOpen]: expandedVehicle,
                                })}
                                onClick={() => setExpandedVehicle(!expandedVehicle)}
                                aria-expanded={expandedVehicle}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon style={{color: theme.palette.type === 'dark' ? 'white' : '#173c60'}}/>
                            </IconButton>
                        </ListItem>
                        <Collapse in={expandedVehicle} timeout="auto" unmountOnExit>
                            <List className={classes.list}>
                                <ListItemText primary={bikeInfo.brand ? `${bikeInfo.brand} ${bikeInfo.model || ''}` : 'Model and brand unknown'} className={classes.listItem} secondary={bikeInfo.imei || ''} />
                                <ListItemText primary={"Frame number"} secondary={bikeInfo.frameNumber} className={classes.listItem}/>
                                {bikeInfo.licensePlate && <ListItemText primary={"License plate"} secondary={bikeInfo.licensePlate} className={classes.listItem}/>}
                            </List>
                        </Collapse>
                        <ListItem>
                            <ListItemAvatar>
                                <Avatar className={classes.avatar}>
                                    <AccessTimeIcon />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={"Last seen"} secondary={lastSeen} />
                        </ListItem>
                        <ListItem>
                            <ListItemAvatar>
                                <Avatar className={classes.avatar}>
                                    <CallIcon/>
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={contactInfo.name || 'No contact name'} secondary={contactInfo.phone || 'No phone number'} />
                        </ListItem>
                    </List>
                    <Typography variant={"caption"} style={{padding: '8px 16px', color: "gray"}}>
                       Reported at {events && events[events.length -1].date}
                    </Typography>
                    <Fireworks enableFireworks={enableFireworks} />
                </Card>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={modalOpen}>
                    <div className={classes.paper}>
                        <ErrorOutlineIcon style={{fontSize: '70px', color: 'orange'}}/>
                        <h2 id="transition-modal-title" style={{margin: '10px 0 20px', fontWeight: 500, color: theme.palette.type === 'dark' ? 'white' : 'black'}}>{modalCase.text}</h2>
                        <Button disableElevation variant={"contained"} className={classes.buttonContinue}
                                onClick={() => {
                                    setModalOpen(false)
                                    setSnackbar({message: 'Waiting on response...', open: true, severity: 'info' })
                                    axios.put(`${backendEndpoint}/investigations/${id}/actions/${modalCase.type}`).then((res) => {
                                        setSnackbar({message: 'Success!', open: true, severity: 'success' })
                                        if(modalCase.type === 'resolve') setEnableFireworks(true)
                                        setClosedCaseModalOpen(true)
                                    }).catch((err) => setSnackbar({message: err.message, open: true, severity: 'error' }))
                                }}>Yes</Button>
                        <Button disableElevation variant={"contained"} className={classes.buttonCancel}
                                onClick={() => setModalOpen(false)}>Cancel</Button>
                    </div>
                </Fade>
            </Modal>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={closedCaseModalOpen}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                    classes: {
                        root: classes.backDrop
                    }
                }}
            >
                <Fade in={closedCaseModalOpen}>
                    <div className={classes.caseClosed} style={{color: theme.palette.type === 'dark' ? 'white' : 'black'}}>
                        {errorOnLoad ? <><Typography variant={"h6"} id="transition-modal-title"
                                                     style={{margin: '10px 0 20px'}}>Case not found</Typography>
                            <Typography variant={"body1"}>Case is resolved/closed/snoozed or case id can't be found.</Typography></> : <><Typography
                            variant={"h6"} id="transition-modal-title"
                            style={{margin: '10px 0 20px'}}>Case: {caseInfo.caseNumber}</Typography>
                            <Typography variant={"body1"}>Case {modalCase.type}d!</Typography></>}
                    </div>
                </Fade>
            </Modal>
            <TripsDrawer tripsDrawerOpen={tripsDrawerOpen} setTripsDrawerOpen={setTripsDrawerOpen} trips={caseInfo.trips} setTrip={setTrip} id={id} setGpsLocation={setMapLocation} />
            <Snackbar snackbar={snackbar} setSnackbar={setSnackbar} />
        </Box>)
}

export default Details
